import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, ref } from 'vue'
import { type SelectOptions } from './types'
import { Select } from 'ant-design-vue'
import { getUserList } from './service'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  isMultiple: {
    type: Boolean,
    default: true,
  },
  useLoginname: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props

const filterOption = (input: string, option: SelectOptions) => {
  return option.label.toLowerCase().includes(input.toLowerCase())
}

const options = ref<SelectOptions[]>()
const getOptions = () => {
  getUserList()
    .then(res => {
      const list = res.records || []

      options.value = list.map(item => {
        return {
          label: item.name,
          value: props.useLoginname ? item.loginname : item.name,
        }
      })
    })
}

onMounted(() => {
  getOptions()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Select), {
    "allow-clear": "",
    "filter-option": filterOption,
    "max-tag-count": 1,
    mode: __props.isMultiple ? 'multiple' : undefined,
    options: options.value,
    placeholder: "请选择",
    "show-search": "",
    style: {"width":"194px"}
  }, null, 8, ["mode", "options"]))
}
}

})